import Phaser from "phaser";

export default class BootScene extends Phaser.Scene {
  constructor() {
    super("BootScene");
  }

  preload() {
    this.load.image("room", "/assets/room.png");
    this.load.image("log", "/assets/log.png"); // SIEM logs
    this.load.image("server", "/assets/server.png"); // vulnerable server
    this.load.image("key", "/assets/key.png"); // exposed API key
    this.load.image("terminal", "/assets/terminal.png"); // terminal / auth
    this.load.image("door", "/assets/door.png");
    this.load.image("vnc", "/assets/vnc.png");
  }

  create() {
    this.scene.start("RoomScene");
  }
}
